import { Component, Input, Output, EventEmitter, ChangeDetectionStrategy, ChangeDetectorRef } from '@angular/core';
import { CurrencyConverterPurePipe } from 'app/shared/currency-converter-pure.pipe';
import { ConfirmationModalComponent } from 'app/shared/modals/confirmation-modal/confirmation-modal.component';
import { BsModalService, ModalOptions } from 'ngx-bootstrap';
import { BaseItemComponent } from '../base-item/base-item.component';

@Component({
  selector: 'usb-hotel-item',
  templateUrl: './hotel-item.component.html',
  styleUrls: ['./hotel-item.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class HotelItemComponent extends BaseItemComponent {
  constructor(
    protected cdr: ChangeDetectorRef,
    protected currency: CurrencyConverterPurePipe,
  ) {
    super(cdr, currency);
  }

  @Input() item: any;
  @Input() clientsSettingAppBooking: any;
  @Output() removeRoom = new EventEmitter<any>();
  displayPrice: number = 0;
  config = {
    animated: true,
    keyboard: true,
    backdrop: 'static',
    ignoreBackdropClick: true,
  };


  getNights(room): number {
    if (!room?.arrivalDate || !room?.departureDate) return 0;
    const arrival = new Date(room.arrivalDate);
    const departure = new Date(room.departureDate);
    const diffTime = Math.abs(departure.getTime() - arrival.getTime());
    return Math.ceil(diffTime / (1000 * 60 * 60 * 24));
  }

  getStatusHotelClass(statusId: number): string {
    const statusMap: { [key: number]: string } = {
      1: 'product-status-saved',
      2: 'product-status-reserved',
      3: 'product-status-locked',
      4: 'product-status-denied',
      5: 'product-status-cancelled',
      6: 'product-status-paid-agency',
      7: 'product-status-paid-provider',
      8: 'product-status-completed'
    };
    return statusMap[statusId] || '';
  }

  ngOnInit() {
    this.computeDisplayPriceHotel();
  }

  getRoomDisplayPrice(room: any): number {
    if (room?.statusId === 5) {
      return 0;
    }
    if (this.item?.isPaidAgency || this.item?.isPaidProvider) {
      return room?.convertedAmounts?.netPriceAgent || room?.netPrice || 0;
    }
    return this.currency.transform(
      room?.netPriceAgent,
      room?.currency,
      this.currencyAgency?.code,
      this.currencies
    ) || 0;
  }

  onRemoveItem(room: any): void {
    this.removeRoom.emit(room);
  }

  private computeDisplayPriceHotel(): void {
    if (this.item?.statusId === 5) {
      this.displayPrice = 0;
      return;
    }
    if (this.item?.isPaidAgency || this.item?.isPaidProvider) {
      this.displayPrice = this.item?.convertedAmounts?.netPriceAgent || this.item?.netPrice || 0;
      return;
    }
    this.displayPrice = this.currency.transform(
      this.item?.netPriceAgent,
      this.item?.currency,
      this.currencyAgency?.code,
      this.currencies
    ) || 0;
  }
}
